import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface ContainerProps {
    children: ReactNode
    className?: string
    size?: 'default' | 'narrow' | 'wide'
}

const SIZES = {
    narrow: 'max-w-3xl',
    default: 'max-w-6xl',
    wide: 'max-w-7xl'
}

export const Container: FC<ContainerProps> = ({
    children,
    className,
    size = 'default'
}): ReactNode => {
    return (
        <div className={cn('mx-auto w-full px-5 sm:px-6 lg:px-8', SIZES[size], className)}>
            {children}
        </div>
    )
}
